(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["face-capture"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('.quiz-face-capture');
    roots.forEach(sectionRoot => {
      if (sectionRoot.dataset.qfcInit === '1') return;
      sectionRoot.dataset.qfcInit = '1';

      const steps = sectionRoot.querySelectorAll('.quiz-face-capture__step');
      const nameInput = sectionRoot.querySelector('input[name="name"]');
      const emailInput = sectionRoot.querySelector('input[name="email"]');
      const phoneInput = sectionRoot.querySelector('input[name="phone"]');
      let submitted = false;
      const sheetURL = 'https://script.google.com/macros/s/AKfycbzRqzieFFKSLaVjBG5qLdSx2Yw_QdN-j1f4o3RjWP9BB6KZGGgm7BlELEJs86LojibodA/exec';

      function validateName() {
        const name = (nameInput.value || '').trim();
        if (!name) {
          alert('Please enter your name.');
          nameInput.focus();
          return false;
        }
        return true;
      }

      function showStep(stepNumber) {
        steps.forEach(step => {
          step.classList.toggle('is-active', Number(step.dataset.step) === stepNumber);
        });
      }

      function triggerKwikpassPopup() {
        const accountSelectors = ['#kp-login-button-header-logo'];
        const triggerUserClick = element => {
          ['pointerdown', 'mousedown', 'mouseup', 'click'].forEach(type => {
            element.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, view: window }));
          });
        };

        for (let i = 0; i < accountSelectors.length; i += 1) {
          const accountNode = document.querySelector(accountSelectors[i]);
          if (accountNode) {
            triggerUserClick(accountNode);
            return true;
          }
        }

        if (window.KwikPass && typeof window.KwikPass.open === 'function') return window.KwikPass.open(), true;
        if (window.KwikPass && typeof window.KwikPass.openModal === 'function') return window.KwikPass.openModal(), true;
        if (window.kwikpass && typeof window.kwikpass.open === 'function') return window.kwikpass.open(), true;
        if (window.SimplifyMyLogin && typeof window.SimplifyMyLogin.open === 'function') return window.SimplifyMyLogin.open(), true;

        const triggerSelectors = [
          '[data-kwikpass-login]',
          '[data-kp-login]',
          '.kwikpass-login',
          '.kp-login',
          '[href*="kwikpass"]',
          '[class*="kwikpass"]'
        ];
        for (let i = 0; i < triggerSelectors.length; i += 1) {
          const node = document.querySelector(triggerSelectors[i]);
          if (node) {
            node.click();
            return true;
          }
        }
        return false;
      }

      function validateContact() {
        const email = (emailInput.value || '').trim();
        const phone = (phoneInput.value || '').trim();
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phonePattern = /^[0-9]{7,15}$/;
        if (!emailPattern.test(email)) {
          alert('Please enter a valid email.');
          emailInput.focus();
          return false;
        }
        if (!phonePattern.test(phone)) {
          alert('Please enter a valid mobile number.');
          phoneInput.focus();
          return false;
        }
        return true;
      }

      sectionRoot.addEventListener('click', event => {
        const trigger = event.target.closest('[data-action]');
        if (!trigger) return;
        const action = trigger.dataset.action;

        if (action === 'start') {
          if (!validateName()) return;
          triggerKwikpassPopup();
          showStep(2);
        }

        if (action === 'back') {
          showStep(1);
        }

        if (action === 'submit') {
          if (!validateContact() || submitted) return;
          submitted = true;
          const data = {
            name: (nameInput.value || '').trim(),
            email: (emailInput.value || '').trim(),
            phone: (phoneInput.value || '').trim()
          };

          fetch(sheetURL, {
            method: 'POST',
            mode: 'no-cors',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
          })
            .then(() => {
              showStep(3);
            })
            .catch(() => {
              submitted = false;
              alert('Unable to submit data right now. Please try again.');
            });
        }

      });

      showStep(1);
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
